import React from "react";
import { faBars, faXmark } from "@fortawesome/pro-regular-svg-icons";
import { Link } from "gatsby";

import { Button } from "components/Button/Button";
import { FaIcon } from "components/FaIcon/FaIcon";
import {
    SignInButton,
    TryFreeButton,
} from "components/layout/Navigation/CTAButtons";
import { MobileMenu } from "components/layout/Navigation/MobileMenu";
import { SingleStoreLogo } from "components/layout/Navigation/SingleStoreLogo";
import { SearchBar } from "components/SearchBar/SearchBar";
import { ThemeSelect } from "components/ThemeSelect/ThemeSelect";

import "./Navigation.scss";

export function Navigation() {
    const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);

    const handleBurgerClick = () => {
        setMobileMenuOpen((open) => !open);
    };

    const lockBodyScroll = () => {
        document.body.style.overflow = "hidden";
    };

    const unlockBodyScroll = () => {
        document.body.style.overflow = "";
    };

    React.useEffect(() => {
        if (mobileMenuOpen) {
            lockBodyScroll();
        } else {
            unlockBodyScroll();
        }
    }, [mobileMenuOpen]);

    let mobileMenu;
    let menuIcon = faBars;

    if (mobileMenuOpen) {
        mobileMenu = <MobileMenu />;
        menuIcon = faXmark;
    }

    return (
        <header className="navigation">
            <div className="navigation-container">
                <div className="navigation-content">
                    <div className="logo-container">
                        <Link to="/" aria-label="Home">
                            <SingleStoreLogo />
                        </Link>
                    </div>

                    <div className="search-container">
                        <SearchBar />
                    </div>

                    <div className="actions-container">
                        <ThemeSelect />
                        <SignInButton />
                        <TryFreeButton />
                    </div>

                    <div className="burger-icon-container">
                        <Button
                            variation="ghost-primary"
                            size="md"
                            aria-label="Open navigation"
                            onClick={handleBurgerClick}
                        >
                            <FaIcon icon={menuIcon} size="lg" />
                        </Button>
                    </div>
                </div>
            </div>

            {mobileMenu}
        </header>
    );
}
